import { BaseContainerModel } from '../../base-container.model';
import {bl_fm_label_list_hdr_RowClass} from '../../../dbschema';

export class FileLabelListContainerModel extends BaseContainerModel {
  bl_fm_label_list_hdr: bl_fm_label_list_hdr_RowClass = new bl_fm_label_list_hdr_RowClass();
}
